export enum NewLineInsertionPosition {
  ABOVE = 'above',
  BELOW = 'below',
}

export const NewLineInsertionPathMode = {
  FIRST_IN_GROUP: 'insertAsTheFirstInGroup',
  AFTER_GROUP: 'insertAfterTheGroup',
  FIRST_ITEM_ABOVE_FIRST_GROUP: 'insertAsTheFirstAboveFirstGroup',
};
